export default __webpack_public_path__ + "static/media/College-min.38586302.png";